import { v2Request } from "../helpers/request";

export interface AdminPermissionCatalogItem {
  id: number;
  key: string;
  label: string;
  description: string;
  sortOrder: number;
}

export interface AdminListItem {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  fileUrl: string | null;
  isSuperAdmin: boolean;
  isOnline: boolean;
  lastLogin: string | null;
  permissionCount: number;
  totalPermissions: number;
}

export interface AdminPermissionsResponse {
  userId: number;
  isSuperAdmin: boolean;
  permissionIds: number[];
}

export const getPermissionCatalog = () => {
  return v2Request(`/admin/permissions/catalog`);
};

export const getAdminsList = () => {
  return v2Request(`/admin/permissions/admins`);
};

export const getAdminPermissions = (userId: number) => {
  return v2Request(`/admin/permissions/admin/${userId}`);
};

export const updateAdminPermissions = (
  userId: number,
  permissionIds: number[],
) => {
  return v2Request(`/admin/permissions/admin/${userId}`, {
    method: "PUT",
    body: JSON.stringify({ permissionIds }),
    headers: { "Content-Type": "application/json" },
  });
};

export interface CreateAdminPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const createAdmin = (payload: CreateAdminPayload) => {
  return v2Request(`/admin/permissions/admins`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });
};

export const getSelfSuperAdminStatus = () => {
  return v2Request(`/admin/permissions/self`);
};

export const getMyPermissions = () => {
  return v2Request(`/admin/permissions/mine`);
};
